import styled from 'styled-components';

export const Table = styled.table`
  margin-top: 10px;
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th {
    padding: 6px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    .h3-5 {
      text-transform: uppercase;
      color: ${({ theme }) => theme.colors.textSecondary};
    }
  }

  tr td {
    padding: 6px;
  }

  tbody tr:nth-child(odd) {
    background-color: ${({ theme }) => theme.colors.btnBgHover};
  }
`;
